import { AuthConfig } from "azure-integration/authConfig";

interface AppConfiguration extends AuthConfig {
  API_URL: string;
  API_AD_SCOPE: string;
  AppTitle?: string;
  // Banner label, e.g. "QA". Set on the QA web app only; empty means no banner (production).
  ENVIRONMENT_BANNER?: string;
  // Azure DevOps build number of the running image, baked in at build time.
  APP_VERSION?: string;
  APPLICATIONINSIGHTS_CONNECTION_STRING: string;
  HOME_URL?: string;
  Links_TripEventAdmin_ViewTrip: string;
  BillingStatusClientIds: string;
  MapboxApiKey: string;
  FormsEnabled_VehicleServiceUpdate: string;
  FormsEnabled_OvertimeRequest: string;
  FormsEnabled_ReceiptSubmission: string;
  FormsEnabled_FuelCard: string;
  FormsEnabled_RideAlong: string;
  FormsEnabled_ShiftClosing: string;
  FormsEnabled_ShiftOverlapAuthorization: string;
}

declare global {
  interface Window {
    _env_: AppConfiguration;
  }
}

export default window._env_;
